var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("live.page_title"),
          "icon-class": "mdi mdi-record-circle-outline"
        }
      }),
      _vm._v(" "),
      _vm.$store.getters.isLiveStreamOnline
        ? _c("div", [
            !_vm.$store.getters.isExecutingRequest
              ? _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "vjs-responsive" },
                      [
                        _c("video-player", {
                          ref: "videoPlayer",
                          staticClass: "vjs-custom-skin",
                          attrs: { options: _vm.playerOptions },
                          on: { ready: _vm.playerReadied }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        : _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "card shadow-sm" }, [
                  _c("div", { staticClass: "card-body text-center" }, [
                    _c("i", {
                      staticClass:
                        "mdi mdi-record-circle-outline text-muted mdi-96px"
                    }),
                    _vm._v(" "),
                    _c("h2", {
                      staticClass: "font-weight-lighter mt-3",
                      domProps: { innerHTML: _vm._s(_vm.$t("live.offline")) }
                    })
                  ])
                ])
              ])
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }